// Desc: Player language configuration
export const i18Config = {
  en: {
    restart: 'Restart',
    qualityLabel: {
      0: 'Auto'
    },
    rewind: 'Rewind 10s',
    play: 'Play',
    pause: 'Pause',
    fastForward: 'Forward 10s',
    seek: 'Seek',
    seekLabel: '{currentTime} of {duration}',
    played: 'Played',
    buffered: 'Buffered',
    currentTime: 'Current time',
    duration: 'Duration',
    volume: 'Volume',
    mute: 'Mute',
    unmute: 'Unmute',
    enableCaptions: 'Enable captions',
    disableCaptions: 'Disable captions',
    download: 'Download',
    enterFullscreen: 'Enter fullscreen',
    exitFullscreen: 'Exit fullscreen',
    frameTitle: 'Player for {title}',
    captions: 'Captions',
    audio: 'Audio',
    chapters: 'Chapters',
    settings: 'Settings',
    pip: 'PIP',
    menuBack: 'Go back to previous menu',
    speed: 'Speed',
    normal: 'Normal',
    quality: 'Quality',
    loop: 'Loop',
    start: 'Start',
    end: 'End',
    all: 'All',
    reset: 'Reset',
    disabled: 'Disabled',
    enabled: 'Enabled',
    advertisement: 'Ad',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: 'Enable sound',
    noInternetConnection: 'You are offline. Please check your internet connection.'

  },
  es: {
    restart: 'Reiniciar',
    qualityLabel: {
      0: 'Automático'
    },
    rewind: 'Rebobinar 10s',
    play: 'Reproducir',
    pause: 'Pausar',
    fastForward: 'Avanzar 10s',
    seek: 'Buscar',
    seekLabel: '{currentTime} de {duration}',
    played: 'Reproducido',
    buffered: 'En búfer',
    currentTime: 'Tiempo actual',
    duration: 'Duración',
    volume: 'Volumen',
    mute: 'Silenciar',
    unmute: 'Activar sonido',
    enableCaptions: 'Activar subtítulos',
    disableCaptions: 'Desactivar subtítulos',
    download: 'Descargar',
    enterFullscreen: 'Entrar en pantalla completa',
    exitFullscreen: 'Salir de pantalla completa,',
    frameTitle: 'Reproductor para {title}',
    captions: 'Subtítulos',
    audio: 'Audio',
    chapters: 'Capítulos',
    settings: 'Configuración',
    pip: 'PIP',
    menuBack: 'Volver al menú anterior',
    speed: 'Velocidad',
    normal: 'Normal',
    quality: 'Calidad',
    loop: 'Repetir',
    start: 'Inicio',
    end: 'Fin',
    all: 'Todo',
    reset: 'Restablecer',
    disabled: 'Desactivado',
    enabled: 'Activado',
    advertisement: 'Anuncio',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: 'Activar sonido',
    noInternetConnection: 'Estás desconectado. Por favor, comprueba tu conexión a Internet.'
  },
  zh: {
    restart: '重新启动',
    qualityLabel: {
      0: '自动'
    },
    rewind: '倒带 10s',
    play: '播放',
    pause: '暂停',
    fastForward: '快进 10s',
    seek: '搜索',
    seekLabel: '{currentTime} 的 {duration}',
    played: '已播放',
    buffered: '已缓冲',
    currentTime: '当前时间',
    duration: '持续时间',
    volume: '音量',
    mute: '静音',
    unmute: '取消静音',
    enableCaptions: '启用字幕',
    disableCaptions: '禁用字幕',
    download: '下载',
    enterFullscreen: '进入全屏模式',
    exitFullscreen: '退出全屏模式',
    frameTitle: '播放器为 {title}',
    captions: '字幕',
    audio: '声音的',
    chapters: '章节',
    settings: '设置',
    pip: '画中画',
    menuBack: '返回上一个菜单',
    speed: '速度',
    normal: '正常',
    quality: '质量',
    loop: '循环',
    start: '开始',
    end: '结束',
    all: '全部',
    reset: '重置',
    disabled: '禁用',
    enabled: '启用',
    advertisement: '广告',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: '启用声音',
    noInternetConnection: '您已离线。请检查您的互联网连接。'
  },
  pt: {
    restart: 'Reiniciar',
    qualityLabel: {
      0: 'Automático'
    },
    rewind: 'Retroceder 10s',
    play: 'Reproduzir',
    pause: 'Pausar',
    fastForward: 'Avançar 10s',
    seek: 'Buscar',
    seekLabel: '{currentTime} de {duration}',
    played: 'Reproduzido',
    buffered: 'Armazenado em buffer',
    currentTime: 'Tempo atual',
    duration: 'Duração',
    volume: 'Volume',
    mute: 'Silenciar',
    unmute: 'Ativar som',
    enableCaptions: 'Ativar legendas',
    disableCaptions: 'Desativar legendas',
    download: 'Baixar',
    enterFullscreen: 'Entrar em tela cheia',
    exitFullscreen: 'Sair da tela cheia',
    frameTitle: 'Reprodutor para {title}',
    captions: 'Legendas',
    audio: 'Áudio',
    chapters: 'Capítulos',
    settings: 'Configurações',
    pip: 'PIP',
    menuBack: 'Voltar ao menu anterior',
    speed: 'Velocidade',
    normal: 'Normal',
    quality: 'Qualidade',
    loop: 'Repetir',
    start: 'Início',
    end: 'Fim',
    all: 'Todos',
    reset: 'Redefinir',
    disabled: 'Desativado',
    enabled: 'Ativado',
    advertisement: 'Anúncio',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: 'Ativar som',
    noInternetConnection: 'Você está offline. Por favor, verifique sua conexão com a Internet.'
  },
  mr: {
    restart: 'पुन्हा सुरू करा',
    qualityLabel: {
      0: 'स्वयंचलित'
    },
    rewind: '१० सेकंद मागे',
    play: 'प्ले',
    pause: 'थांबा',
    fastForward: '१० सेकंद पुढे',
    seek: 'शोधा',
    seekLabel: '{currentTime} / {duration}',
    played: 'वाजवलेले',
    buffered: 'बफर केलेले',
    currentTime: 'चालू वेळ',
    duration: 'कालावधी',
    volume: 'आवाज',
    mute: 'म्यूट',
    unmute: 'अनम्यूट',
    enableCaptions: 'उपशीर्षके सक्षम करा',
    disableCaptions: 'उपशीर्षके अक्षम करा',
    download: 'डाउनलोड',
    enterFullscreen: 'पूर्ण स्क्रीनमध्ये जा',
    exitFullscreen: 'पूर्ण स्क्रीनमधून बाहेर पडा',
    frameTitle: '{title} साठी प्लेयर',
    captions: 'उपशीर्षके',
    audio: 'ऑडिओ',
    chapters: 'चैप्टर',
    settings: 'सेटिंग्ज',
    pip: 'चित्र-आत-चित्र',
    menuBack: 'मागील मेनूमध्ये परत जा',
    speed: 'गती',
    normal: 'सामान्य',
    quality: 'गुणवत्ता',
    loop: 'लूप',
    start: 'सुरू',
    end: 'शेवट',
    all: 'सर्व',
    reset: 'रीसेट',
    disabled: 'अक्षम',
    enabled: 'सक्षम',
    advertisement: 'जाहिरात',
    qualityBadge: {
      2160: '४के',
      1440: 'एचडी',
      1080: 'एचडी',
      720: 'एचडी',
      540: 'एसडी',
      480: 'एसडी',
      360: 'एसडी',
      240: 'एसडी'
    },
    enableSound: 'आवाज सक्षम करा',
    noInternetConnection: 'तुम्ही ऑफलाइन आहात. कृपया तुमचे इंटरनेट कनेक्शन तपासा.'
  },
  ta: {
    restart: 'மீண்டும் தொடங்கு',
    qualityLabel: {
      0: 'தானியங்கி'
    },
    rewind: '10 விநாடிகள் பின்னோக்கி',
    play: 'இயக்கு',
    pause: 'இடைநிறுத்து',
    fastForward: '10 விநாடிகள் முன்னோக்கி',
    seek: 'தேடு',
    seekLabel: '{currentTime} / {duration}',
    played: 'இயக்கப்பட்டது',
    buffered: 'பஃபர் செய்யப்பட்டது',
    currentTime: 'தற்போதைய நேரம்',
    duration: 'கால அளவு',
    volume: 'ஒலி அளவு',
    mute: 'அமைதி',
    unmute: 'அமைதி நீக்கு',
    enableCaptions: 'சுருக்கவுரை செயல்படுத்தவும்',
    disableCaptions: 'சுருக்கவுரை செயல்திறன் நீக்கு',
    download: 'பதிவிறக்கு',
    enterFullscreen: 'முழு திரையில் செல்',
    exitFullscreen: 'முழு திரையில் இருந்து வெளியேறு',
    frameTitle: '{title} உடன் பிளேயர்',
    captions: 'சுருக்கவுரை',
    audio: 'ஒலி',
    settings: 'அமைப்புகள்',
    pip: 'படத்தில் படம்',
    menuBack: 'முன்னைய மெனுவிற்கு செல்',
    speed: 'வேகம்',
    normal: 'சாதாரணம்',
    quality: 'தரம்',
    loop: 'மறுமுறை',
    start: 'தொடக்கம்',
    end: 'முடிவு',
    all: 'அனைத்தும்',
    reset: 'மீட்டமை',
    disabled: 'நிறுத்தப்பட்டது',
    enabled: 'செயல்படுத்தப்பட்டது',
    advertisement: 'விளம்பரம்',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: 'ஒலி செயல்படுத்தவும்',
    noInternetConnection: 'நீங்கள் ஆஃப்லைனில் உள்ளீர்கள். உங்கள் இணைய இணைப்பை சரிபார்க்கவும்.'
  },
  te: {
    restart: 'మళ్లీ ప్రారంభించు',
    qualityLabel: {
      0: 'ఆటో'
    },
    rewind: '10 సెకండ్లు వెనుకకు',
    play: 'ప్లే',
    pause: 'విరామం',
    fastForward: '10 సెకండ్లు ముందుకు',
    seek: 'వెతుకు',
    seekLabel: '{currentTime} / {duration}',
    played: 'ప్లే చేయబడింది',
    buffered: 'బఫర్ చేయబడింది',
    currentTime: 'ప్రస్తుత సమయం',
    duration: 'వ్యవధి',
    volume: 'వాల్యూమ్',
    mute: 'మ్యూట్',
    unmute: 'అన్‌మ్యూట్',
    enableCaptions: 'కాప్షన్లను ప్రారంభించు',
    disableCaptions: 'కాప్షన్లను ఆపి వేయి',
    download: 'డౌన్లోడ్',
    enterFullscreen: 'పూర్తి స్క్రీన్‌లోకి వెళ్లండి',
    exitFullscreen: 'పూర్తి స్క్రీన్ నుండి బయటికి రావడం',
    frameTitle: '{title} కోసం ప్లేయర్',
    captions: 'కాప్షన్లు',
    audio: 'ఆడియో',
    settings: 'సెట్టింగ్‌లు',
    pip: 'చిత్రం-లో-చిత్రం',
    menuBack: 'మునుపటి మెనూకి వెళ్ళండి',
    speed: 'వేగం',
    normal: 'సాధారణం',
    quality: 'నాణ్యత',
    loop: 'లూప్',
    start: 'ప్రారంభం',
    end: 'ముగింపు',
    all: 'అన్ని',
    reset: 'రీసెట్',
    disabled: 'డిసేబుల్ చేయబడింది',
    enabled: 'ఎనేబుల్ చేయబడింది',
    advertisement: 'జాహీరం',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: 'సౌండ్ ప్రారంభించు',
    noInternetConnection: 'మీరు ఆఫ్లైన్‌లో ఉన్నారు. దయచేసి మీ ఇంటర్నెట్ కనెక్షన్‌ను తనిఖీ చేయండి.'
  },
  kn: {
    restart: 'ಮತ್ತೆ ಪ್ರಾರಂಭಿಸಿ',
    qualityLabel: {
      0: 'ಸ್ವಯಂಚಾಲಿತ'
    },
    rewind: '10 ಸೆಕೆಂಡು ಹಿಂದುಗಡೆ',
    play: 'ಪ್ಲೇ',
    pause: 'ವಿರಾಮ',
    fastForward: '10 ಸೆಕೆಂಡು ಮುಂದಕ್ಕೆ',
    seek: 'ಹುಡುಕಿ',
    seekLabel: '{currentTime} / {duration}',
    played: 'ಆಡಿದೆ',
    buffered: 'ಬಫರ್ ಮಾಡಲಾಗಿದೆ',
    currentTime: 'ಪ್ರಸ್ತುತ ಸಮಯ',
    duration: 'ಅವಧಿ',
    volume: 'ಶಬ್ದದ ಮಟ್ಟ',
    mute: 'ಮ್ಯೂಟ್',
    unmute: 'ಅನ್‌ಮ್ಯೂಟ್',
    enableCaptions: 'శీర్షికలను ప్రారంభించండి',
    disableCaptions: 'శీర్షికలను ఆఫ్ చేయండి',
    download: 'ಡೌನ್‌ಲೋಡ್',
    enterFullscreen: 'ಪೂರ್ಣ ಪರದೆಗೆ ಪ್ರವೇಶಿಸಿ',
    exitFullscreen: 'ಪೂರ್ಣ ಪರದೆಗಿಂದ ನಿರ್ಗಮಿಸಿ',
    frameTitle: 'కోసం ప్లేయర్ {title}',
    captions: 'ಸಂಗ್ರಹಗಳು',
    audio: 'ಆಡಿಯೊ',
    settings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    pip: 'ಚಿತ್ರದಲ್ಲಿ ಚಿತ್ರ',
    menuBack: 'ಹಿಂದಿನ ಮೆನುವಿಗೆ ಹೋಗಿ',
    speed: 'ವೇಗ',
    normal: 'ಸಾಮಾನ್ಯ',
    quality: 'ಗುಣಮಟ್ಟ',
    loop: 'ಲೂಪ್',
    start: 'ಪ್ರಾರಂಭ',
    end: 'ಅಂತ್ಯ',
    all: 'ಎಲ್ಲಾ',
    reset: 'ಮರುಹೊಂದಿಸಿ',
    disabled: 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
    enabled: 'ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
    advertisement: 'ಜಾಹೀರಾತು',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: 'ಶಬ್ದವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ',
    noInternetConnection: 'ನೀವು ಆಫ್‌ಲೈನ್‌ ಇದ್ದೀರಿ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕವನ್ನು ಪರಿಶೀಲಿಸಿ.'
  },
  ja: {
    restart: '再起動',
    qualityLabel: {
      0: '自動'
    },
    rewind: '10秒巻き戻し',
    play: '再生',
    pause: '一時停止',
    fastForward: '10秒早送り',
    seek: 'シーク',
    seekLabel: '{currentTime} / {duration}',
    played: '再生済み',
    buffered: 'バッファ済み',
    currentTime: '現在の時間',
    duration: '時間',
    volume: '音量',
    mute: 'ミュート',
    unmute: 'ミュート解除',
    enableCaptions: '字幕を有効にする',
    disableCaptions: '字幕を無効にする',
    download: 'ダウンロード',
    enterFullscreen: '全画面表示にする',
    exitFullscreen: '全画面表示を終了する',
    frameTitle: '{title} のプレーヤー',
    captions: '字幕',
    audio: 'オーディオ',
    settings: '設定',
    pip: 'ピクチャ・イン・ピクチャ',
    menuBack: '前のメニューに戻る',
    speed: '速度',
    normal: '標準',
    quality: '品質',
    loop: 'ループ',
    start: '開始',
    end: '終了',
    all: 'すべて',
    reset: 'リセット',
    disabled: '無効',
    enabled: '有効',
    advertisement: '広告',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: '音声を有効にする',
    noInternetConnection: 'オフラインです。インターネット接続を確認してください。'
  },
  fr: {
    restart: 'Redémarrer',
    qualityLabel: {
      0: 'Auto'
    },
    rewind: 'Reculer de 10 secondes',
    play: 'Lecture',
    pause: 'Pause',
    fastForward: 'Avancer de 10 secondes',
    seek: 'Rechercher',
    seekLabel: '{currentTime} sur {duration}',
    played: 'Lu',
    buffered: 'Mis en mémoire tampon',
    currentTime: 'Temps actuel',
    duration: 'Durée',
    volume: 'Volume',
    mute: 'Couper le son',
    unmute: 'Rétablir le son',
    enableCaptions: 'Activer les sous-titres',
    disableCaptions: 'Désactiver les sous-titres',
    download: 'Télécharger',
    enterFullscreen: 'Passer en plein écran',
    exitFullscreen: 'Quitter le plein écran',
    frameTitle: 'Lecteur pour {title}',
    captions: 'Sous-titres',
    audio: 'Audio',
    settings: 'Paramètres',
    pip: "Image dans l'image",
    menuBack: 'Revenir au menu précédent',
    speed: 'Vitesse',
    normal: 'Normal',
    quality: 'Qualité',
    loop: 'Boucle',
    start: 'Début',
    end: 'Fin',
    all: 'Tout',
    reset: 'Réinitialiser',
    disabled: 'Désactivé',
    enabled: 'Activé',
    advertisement: 'Publicité',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: 'Activer le son',
    noInternetConnection: 'Vous êtes hors ligne. Veuillez vérifier votre connexion Internet.'
  },
  de: {
    restart: 'Neustarten',
    qualityLabel: {
      0: 'Auto'
    },
    rewind: '10 Sekunden zurückspulen',
    play: 'Abspielen',
    pause: 'Pause',
    fastForward: '10 Sekunden vorspulen',
    seek: 'Suchen',
    seekLabel: '{currentTime} von {duration}',
    played: 'Abgespielt',
    buffered: 'Gepuffert',
    currentTime: 'Aktuelle Zeit',
    duration: 'Dauer',
    volume: 'Lautstärke',
    mute: 'Stummschalten',
    unmute: 'Stummschaltung aufheben',
    enableCaptions: 'Untertitel aktivieren',
    disableCaptions: 'Untertitel deaktivieren',
    download: 'Herunterladen',
    enterFullscreen: 'Vollbildmodus aktivieren',
    exitFullscreen: 'Vollbildmodus beenden',
    frameTitle: 'Player für {title}',
    captions: 'Untertitel',
    audio: 'Audio',
    settings: 'Einstellungen',
    pip: 'Bild-in-Bild',
    menuBack: 'Zum vorherigen Menü zurückkehren',
    speed: 'Geschwindigkeit',
    normal: 'Normal',
    quality: 'Qualität',
    loop: 'Schleife',
    start: 'Start',
    end: 'Ende',
    all: 'Alle',
    reset: 'Zurücksetzen',
    disabled: 'Deaktiviert',
    enabled: 'Aktiviert',
    advertisement: 'Anzeige',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: 'Ton aktivieren',
    noInternetConnection: 'Sie sind offline. Bitte überprüfen Sie Ihre Internetverbindung.'
  },
  nl: {
    restart: 'Herstarten',
    qualityLabel: {
      0: 'Auto'
    },
    rewind: '10 seconden terugspoelen',
    play: 'Afspelen',
    pause: 'Pauzeren',
    fastForward: '10 seconden vooruitspoelen',
    seek: 'Zoeken',
    seekLabel: '{currentTime} van {duration}',
    played: 'Afgespeeld',
    buffered: 'Gebufferd',
    currentTime: 'Huidige tijd',
    duration: 'Duur',
    volume: 'Volume',
    mute: 'Dempen',
    unmute: 'Dempen opheffen',
    enableCaptions: 'Ondertiteling inschakelen',
    disableCaptions: 'Ondertiteling uitschakelen',
    download: 'Downloaden',
    enterFullscreen: 'Volledig scherm inschakelen',
    exitFullscreen: 'Volledig scherm afsluiten',
    frameTitle: 'Speler voor {title}',
    captions: 'Ondertiteling',
    audio: 'Audio',
    settings: 'Instellingen',
    pip: 'Beeld-in-beeld',
    menuBack: 'Terug naar vorig menu',
    speed: 'Snelheid',
    normal: 'Normaal',
    quality: 'Kwaliteit',
    loop: 'Herhalen',
    start: 'Begin',
    end: 'Einde',
    all: 'Alles',
    reset: 'Herstellen',
    disabled: 'Uitgeschakeld',
    enabled: 'Ingeschakeld',
    advertisement: 'Advertentie',
    qualityBadge: {
      2160: '4K',
      1440: 'HD',
      1080: 'HD',
      720: 'HD',
      540: 'SD',
      480: 'SD',
      360: 'SD',
      240: 'SD'
    },
    enableSound: 'Geluid inschakelen',
    noInternetConnection: 'Je bent offline. Controleer je internetverbinding.'
  }
}
